import type { IGetMockupResponse } from "../types/response.type";
import type { IRawSurfacesData, IRow } from "../types/table.types";
import RequestHelper from "../utils/abort-controller";


export default class RenderPreviewService {
  private apigateway: string;
  private backoffice: string;
  private tenantId: string;
  private ownerId: string;
  private token: string;
  private sku: string;

  constructor(options: { apigateway: string, backoffice: string, token: string, tenantId: string, userId: string, sku: string }) {
    this.apigateway = options.apigateway;
    this.backoffice = options.backoffice;
    this.token = options.token;
    this.tenantId = options.tenantId;
    this.ownerId = options.userId;
    this.sku = options.sku;
  }

  public async getPreviewMockups(productId: string, productVersionId: string): Promise<IGetMockupResponse[]> {
    const method = "GET";
    const url = new URL(this.backoffice);
    url.pathname = `api/storefront/v1/products/${productId}/variant-mockups`;
    url.searchParams.set("productVersionId", productVersionId);
    url.searchParams.set("takeAvailableOnly", "true");
    url.searchParams.set("tenantId", this.tenantId);
    url.searchParams.set("sku", this.sku);

    return await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`,
      },
    }).then((res) => res.json()).then((res) => {
      const items = res.items;
      return items.filter((item: IGetMockupResponse) => item.mockupType === 'Preview');
    });
  }

  public async getPreviewVDP(rowObject: IRow, surfacesData: IRawSurfacesData | null, designId: string, mockupId: string): Promise<string | null> {
    const method = "POST";
    const url = new URL(this.apigateway);
    url.pathname = `/api/atoms/v1/designs/render-preview`;
    url.searchParams.set("attachment", "false");
    url.searchParams.set("tenantId", this.tenantId);

    const variableData = Object.entries(rowObject.row).map(([key, value]) => {
      const fieldTypeObject: Record<string, string> | undefined = (surfacesData) ? surfacesData.columnsTypes.find((columnType) => columnType[key]) : undefined;
      const fieldType: string = (fieldTypeObject) ? fieldTypeObject[key] : "Text";
      return {
        name: key,
        value: (fieldType === 'Text') ? value : value || null,
        type: fieldType,
      };
    });

    const body = {
      ownerId: this.ownerId,
      renderingConfig: {
        surfaceIndex: 0,
        width: 700,
        height: 700,
        fileFormat: "Jpeg",
      },
      designId,
      mockupId,
      variableData,
    };
    try {
      return await fetch(url.href, {
        signal: RequestHelper.abortController?.signal,
        method,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${this.token}`,
        },
        body: JSON.stringify(body),
      }).then((res) => res.blob()).then((blob) => URL.createObjectURL(blob));
    } catch (err) {
      return null;
    }
  }

}
